import React, {useMemo, useCallback} from 'react';
import styled from 'styled-components';
import SelectDropdown from '../../../../../../components/Common/SelectDropdown/SelectDropdown';
import Checkbox from '../../../../../../components/Common/BaseComponentWrappers/MotifCheckbox';
import {labels} from '../../../../../../util/utils';

function CompareDocumentDropdown({options, setOptions, selectedCount}) {
	const onChange = useCallback(
		(option) => {
			switch (option.level) {
				case 0: {
					const mapped = options.map((item) => {
						if (!item.disabled) {
							return {
								label: item.label,
								value: item.value,
								level: item.level,
								isChecked: !option.isChecked,
								disabled: item.disabled
							};
						}

						return item;
					});

					setOptions(mapped);

					break;
				}

				case 1: {
					const mapped = options.map((item) => {
						if (item.value === option.value && !item.disabled) {
							return {
								label: item.label,
								value: item.value,
								level: item.level,
								isChecked: !option.isChecked,
								disabled: item.disabled
							};
						}

						return item;
					});

					const length = mapped.filter((item) => item.isChecked === true && item.level === 1).length;

					mapped.find((item) => item.value === 'select_all').isChecked = length === options.length - 1;

					setOptions(mapped);

					break;
				}

				default:
					break;
			}
		},
		[options, setOptions]
	);

	const formLabel = useMemo(() => {
		return selectedCount > 0 ? selectedCount > 1 ? labels.selectedDocumentsCount.replace('{0}', selectedCount) : labels.selectedDocumentCount.replace('{0}', selectedCount) : labels.selectDocuments;
	}, [selectedCount]);

	const formatOptionLabel = useCallback(
		(option) => {
			return (
				<section
					className="selectListOption"
					onClick={() => {
						onChange(option);
					}}
					disabled={option.disabled}
				>
					<Checkbox
						styleName="compareCheckbox"
						label={option.label}
						checked={option.isChecked}
						ellipse
						noOfLines={1}
						disabled={option.disabled}
					/>
				</section>
			);
		},
		[onChange]
	);

	return (
		<StyledCompareDropdown className="StyledCompareDropdown">
			<SelectDropdown
				options={options}
				noOptionsMessage={() => labels.noResultsFound}
				className={'compareDocumentsDropdown'}
				formLabel={formLabel}
				isMulti
				closeMenuOnSelect={false}
				controlShouldRenderValue={false}
				onClick={() => {}}
				formatOptionLabel={formatOptionLabel}
			/>
		</StyledCompareDropdown>
	);
}

export default CompareDocumentDropdown;

const StyledCompareDropdown = styled.section`
	.compareDocumentsDropdown {
		&.SelectDropdownContainer {
			background-color: var(--neutrals-00white);
			border: var(--px-1) solid var(--neutrals-200);
			border-radius: var(--px-8);
			height: var(--px-54);
			width: calc(100% - var(--px-300));
			&:hover {
				border: var(--px-1) solid var(--neutrals-900) !important;
			}
			&.select-disabled {
				cursor: not-allowed !important;
				&.FormLabelAvailable {
					&.floating-label {
						.react-select-label {
							cursor: not-allowed !important;
						}
					}
				}
				&:hover {
					border: var(--px-1) solid var(--neutrals-200) !important;
				}
			}
			&.DropdownMenuOptionsOpened {
				border-color: var(--neutrals-900);
				border-radius: var(--px-8) var(--px-8) 0 0;
				.react-select-container {
					.react-select__menu {
						border: var(--px-1) solid var(--neutrals-900) !important;
						border-top: 0 !important;
						border-radius: 0 0 var(--px-8) var(--px-8);
						margin: calc(var(--px-1) * -1) 0 0 calc(var(--px-1) * -1) !important;
						width: calc(100% + var(--px-2)) !important;
						background-color: var(--neutrals-00white) !important;
						.react-select__menu-list {
							background-color: transparent;
							.react-select__option {
								background-color: transparent;
								padding: var(--px-13) var(--px-12);
								.selectListOption {
									font-size: var(--px-14);
									font-weight: 300;
									line-height: var(--px-22);
									color: var(--neutrals-900);
								}
								&.react-select__option--is-disabled {
									cursor: default;
									color: var(--neutrals-300);
								}
								&:hover {
									cursor: pointer !important;
								}
								&.react-select__option--is-selected {
									font-weight: 600;
									&:last-child {
										border-radius: 0 0 var(--px-8) var(--px-8);
									}
								}
								&:last-child {
									border-radius: 0 0 var(--px-8) var(--px-8);
								}
							}
						}
						.StyledAddDescriptionLabel {
							border-radius: 0 0 var(--px-8) var(--px-8);
						}
					}
				}
				&.select-up {
					border-radius: 0 0 var(--px-8) var(--px-8);
					.react-select-container {
						.react-select__menu {
							border-top: var(--px-1) solid var(--neutrals-900) !important;
							border-bottom: 0 !important;
							border-radius: var(--px-8) var(--px-8) 0 0 !important;
							margin-bottom: var(--px-1) !important;
							.react-select__menu-list {
								.react-select__option {
									&:last-child {
										border-radius: 0;
									}
									&:first-child {
										border-radius: var(--px-8) var(--px-8) 0 0;
									}
								}
							}
						}
					}
					&.DropdownMenuOptionsOpened {
						.react-select-container {
							.react-select__menu {
								.StyledAddDescriptionLabel {
									border-radius: 0 !important;
								}
							}
						}
					}
				}
			}
			&.DropdownMenuOptionsClosed {
				border-radius: var(--px-8);
			}
			&.FormLabelAvailable {
				.react-select-label {
					font-size: var(--px-14);
					font-weight: 300;
					line-height: var(--px-22);
					color: var(--neutrals-700);
				}
				&.floating-label {
					&.select-disabled {
						.react-select-label {
							color: var(--neutrals-300);
						}
						.assessRiskOptionText {
							color: var(--neutrals-300);
						}
					}
					.react-select-label {
						font-size: var(--px-12);
						line-height: var(--px-16);
						padding-left: var(--px-2);
						top: var(--px-8);
					}
					.react-select__single-value {
						margin: 0 !important;
						padding-top: var(--px-8) !important;
					}
				}
			}
			&.RelateMultyEntitiesDropdown {
				&.select-up {
					border-radius: var(--px-8) var(--px-8) 0 0 !important;
					&.DropdownMenuOptionsOpened {
						border: var(--px-1) solid var(--neutrals-900) !important;
						.react-select-container {
							.react-select__menu {
								border: var(--px-1) solid var(--neutrals-900) !important;
								border-top: 0 !important;
								border-radius: 0 0 var(--px-8) var(--px-8) !important;
								margin: calc(var(--px-1) * -1) 0 0 calc(var(--px-1) * -1) !important;
								width: calc(100% + var(--px-2)) !important;
								background-color: var(--neutrals-00white) !important;
								top: 100%;
								bottom: auto;
								.react-select__menu-list {
									background-color: transparent;
									margin-bottom: var(--px-3);
									.react-select__option {
										background-color: transparent;
										font-size: var(--px-14);
										font-weight: 300;
										line-height: var(--px-22);
										padding: var(--px-13) var(--px-12);
										color: var(--neutrals-900);
										&.react-select__option--is-disabled {
											cursor: default;
											color: var(--neutrals-300);
										}
										&:hover {
											cursor: pointer !important;
											background-color: var(--neutrals-200);
										}
										&.react-select__option--is-selected {
											background-color: var(--neutrals-200);
											font-weight: 600;
											&:last-child {
												border-radius: 0 0 var(--px-8) var(--px-8);
											}
										}
										&:last-child {
											border-radius: 0 0 var(--px-8) var(--px-8);
										}
									}
								}
							}
						}
					}
					&.DropdownMenuOptionsClosed {
						border-radius: var(--px-8) !important;
					}
				}
			}
			.react-select-container {
				font-size: var(--px-14);
				font-weight: 300;
				.react-select__control {
					min-height: var(--px-54);
					border: 0 !important;
					background-color: transparent !important;
					.react-select__single-value {
						top: 53% !important;
					}
					.react-select__input {
						padding-top: var(--px-11);
						background-color: transparent !important;
					}
					.react-select__value-container {
						padding-left: var(--px-12) !important;
						margin: 0;
						.react-select__single-value {
							font-size: var(--px-14);
							font-weight: 300;
							line-height: var(--px-22);
						}
						&:not(.react-select__value-container--is-multi) > div {
							margin: 0;
							padding: 0;
						}
					}
					.react-select__indicators {
						.react-select__clear-indicator {
							padding: var(--px-8) var(--px-4) !important;
							.motif-icon {
								svg {
									width: var(--px-16) !important;
									height: var(--px-16) !important;
								}
							}
						}
						.react-select__dropdown-indicator {
							padding-right: var(--px-12) !important;
						}
					}
				}
			}
		}
	}

	.compareCheckbox {
		padding-right: var(--px-12);
		width: 100%;
		.motif-checkbox {
			top: 0;
			display: inline-flex;
			.motif-checkbox-label {
				max-width: calc(100% - var(--px-30));
				display: inline-block;
				width: auto;
				margin-left: var(--px-10);
			}
		}
	}
`;
